import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/usuarios_cliente/LoginPage";
import AccountLayout from "../pages/usuarios_cliente/AccountLayout";
import AccountHome from "../pages/usuarios_cliente/AccountHome";
import AccountOrders from "../pages/usuarios_cliente/AccountOrders";
import AccountProfile from "../pages/usuarios_cliente/AccountProfile";
import AccountAddresses from "../pages/usuarios_cliente/AccountAddresses";
import ForgotPasswordClientePage from "../pages/usuarios_cliente/password/ForgotPasswordClientePage";
import ResetPasswordClientePage from "../pages/usuarios_cliente/password/ResetPasswordClientePage";

export default function ClienteRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/recuperar-contrasena" element={<ForgotPasswordClientePage />} />
      <Route path="/restablecer-contrasena" element={<ResetPasswordClientePage />} />
      <Route element={<AccountLayout />}>
        <Route index element={<AccountHome />} />
        <Route path="orders" element={<AccountOrders />} />
        <Route path="profile" element={<AccountProfile />} />
        <Route path="addresses" element={<AccountAddresses />} />

        <Route path="*" element={<Navigate to="/cliente" replace />} />
      </Route>
    </Routes>
  );
}